function initTabs() {
  if ($('.tabs-module').length == 0) {
    return false;
  }

  $('.tabs-module-tab').each(function () {
    if ($(this).data('index') == 0) {
      $(this).addClass('tab-active');
    }
  });

  $('.tabs-module-tab').on('click', function () {
    const tabId = $(this).attr('id');
    $('.tabs-module-tab').not(this).removeClass('tab-active');
    $(this).addClass('tab-active');
    $('.tabs-module-item').removeClass('show');
    $('.tabs-module-item[data-target="#' + tabId + '"]').addClass('show');
  });
}

export { initTabs }



// WEBPACK FOOTER //
// ./scripts/modules/tabs.js